import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Buat Pajak Barang Baru ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "flex flex-row h-full pb-4" }
const _hoisted_7 = {
  class: "w-full px-4 text-12px xxl:text-14px pb-24 overflow-y-auto",
  style: {"padding-right":"40%"}
}
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "py-2 w-full" }, [
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Kota Asal, Komoditas, dan Periode Aktif tidak boleh sama dengan Pajak Barang yang sudah tersedia pada status aktif. ")
], -1)
const _hoisted_10 = { class: "py-2 w-full" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Kota Asal", -1)
const _hoisted_12 = { class: "text-red-lp-100 text-12px xxl:text-14px mt-2 ml-1" }
const _hoisted_13 = { class: "py-2 w-full" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Komoditas", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("sadasdasd ")
const _hoisted_16 = { class: "text-red-lp-100 text-12px xxl:text-14px mt-2 ml-1" }
const _hoisted_17 = { class: "py-2 w-full" }
const _hoisted_18 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Deminimus ")
const _hoisted_20 = { class: "ml-1 relative" }
const _hoisted_21 = { class: "flex flex-row items-center relative w-1/3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " $ ", -1)
const _hoisted_23 = { class: "py-2 w-full flex flex-row" }
const _hoisted_24 = { class: "w-1/3" }
const _hoisted_25 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Biaya Masuk ")
const _hoisted_27 = { class: "ml-1 relative" }
const _hoisted_28 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_30 = { class: "w-1/3" }
const _hoisted_31 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" PPH ")
const _hoisted_33 = { class: "ml-1 relative" }
const _hoisted_34 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_36 = { class: "w-1/3" }
const _hoisted_37 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" PPN ")
const _hoisted_39 = { class: "ml-1 relative" }
const _hoisted_40 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-700 rounded-r-md text-black-lp-300 text-center my-1.5 border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2.5" }, " % ", -1)
const _hoisted_42 = { class: "py-4 border-t border-gray-lp-400" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }, " Periode Aktif ", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Pajak barang akan aktif sesuai dengan tanggal periode yang dipilih. ", -1)
const _hoisted_45 = { class: "flex flex-row w-full" }
const _hoisted_46 = { class: "w-3/5 py-3 mr-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Dimulai Dari ")
  ])
], -1)
const _hoisted_48 = { class: "flex flex-row w-full" }
const _hoisted_49 = {
  class: "absolute inset-y-0 flex items-center text-gray-700 bg-white h-6 w-6",
  style: {"right":"3px","top":"5px"}
}
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "warning"
}, null, -1)
const _hoisted_51 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-2"
}
const _hoisted_52 = {
  key: 1,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-2"
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Masa berlaku Pajak Barang")
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" sudah tersedia dengan ")
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Kota Asal dan Komoditas yang sama.")
const _hoisted_58 = { class: "text-red-lp-100 text-12px xxl:text-14px mt-2" }
const _hoisted_59 = { class: "w-3/5 py-3 ml-2" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createVNode("div", { class: "w-13/20 mr-4" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Sampai")
  ])
], -1)
const _hoisted_61 = { class: "flex flex-row w-full" }
const _hoisted_62 = {
  class: "absolute inset-y-0 flex items-center text-gray-700 bg-white h-6 w-6",
  style: {"right":"3px","top":"5px"}
}
const _hoisted_63 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "warning"
}, null, -1)
const _hoisted_64 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-2"
}
const _hoisted_65 = { class: "text-red-lp-100 text-12px xxl:text-14px mt-2" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Masa berlaku Pajak Barang")
const _hoisted_67 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" sudah tersedia dengan ")
const _hoisted_69 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Kota Asal dan Komoditas yang sama.")
const _hoisted_71 = { class: "text-red-lp-100 text-12px xxl:text-14px mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MultipleSelectCity = _resolveComponent("MultipleSelectCity")!
  const _component_SelectSearchOriginDestination = _resolveComponent("SelectSearchOriginDestination")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              (_ctx.isSaveable)
                ? (_openBlock(), _createBlock(_component_button_fill, {
                    key: 0,
                    title: "Simpan",
                    onClick: _ctx.onOpenSave,
                    class: "px-8 bg-red-lp-300"
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_button_fill, {
                    key: 1,
                    title: "Simpan",
                    class: "px-8 cursor-default",
                    style: {"background-color":"#a7a8aa","border-color":"#a7a8aa"}
                  }))
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_MultipleSelectCity, {
                    modelValue: _ctx.city,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.city = $event)),
                    placeholder: "Ketik atau pilih kota asal"
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode("span", _hoisted_12, "Data pajak barang sudah tersedia", 512), [
                    [_vShow, _ctx.isExist || _ctx.isErrorValidation]
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_SelectSearchOriginDestination, {
                    placeholder: "Ketik atau pilih nama komoditas",
                    value: _ctx.commodityName,
                    dataSearch: _ctx.commodityList,
                    onSearch: _ctx.onSearchCommodity,
                    onOpenSearch: _ctx.onOpenCommodity,
                    onCloseSearch: _ctx.onCloseCommodity,
                    onChooseSearch: _ctx.onChooseCommodity,
                    isOpenSearch: _ctx.isOpenCommodity,
                    notFound: _ctx.commodityList.length < 1,
                    isError: _ctx.isExist || _ctx.isErrorValidation,
                    class: "w-full"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["value", "dataSearch", "onSearch", "onOpenSearch", "onCloseSearch", "onChooseSearch", "isOpenSearch", "notFound", "isError"]),
                  _withDirectives(_createVNode("span", _hoisted_16, "Data pajak barang sudah tersedia", 512), [
                    [_vShow, _ctx.isExist || _ctx.isErrorValidation]
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("div", _hoisted_20, [
                      _createVNode("img", {
                        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenDeminimus(true))),
                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onOpenDeminimus(false))),
                        src: 
                    _ctx.isOpenDeminimus
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: ""
                      }, null, 40, ["src"]),
                      _withDirectives(_createVNode(_component_Tooltip, {
                        title: "Deminimus",
                        message: "Batas minimal harga barang (Deminimus) saat ini adalah 3$ per barang.",
                        footer: "",
                        isArrowBottom: false,
                        style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                      }, null, 512), [
                        [_vShow, _ctx.isOpenDeminimus]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.deminimus = $event)),
                      onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setDeminimus && _ctx.setDeminimus(...args))),
                      placeholder: "e.g 1",
                      type: "text",
                      class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3"
                    }, null, 544), [
                      [_vModelText, _ctx.deminimus]
                    ]),
                    _hoisted_22
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode("div", _hoisted_27, [
                        _createVNode("img", {
                          onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onOpenBiayaMasuk(true))),
                          onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onOpenBiayaMasuk(false))),
                          src: 
                      _ctx.isOpenBiayaMasuk
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "Biaya Masuk",
                          message: "Tarif Bea Masuk (BM) akan dikenakan untuk barang dengan nilai Deminimus lebih dari 3$ sebesar 7,5% kecuali 4 komoditi (Tas, Sepatu, Produk Tekstil) akan dikenakan 15% - 20%, 25% - 30%, dan 15% - 25%.",
                          footer: "",
                          isArrowBottom: false,
                          style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                        }, null, 512), [
                          [_vShow, _ctx.isOpenBiayaMasuk]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.biayaMasuk = $event)),
                        onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.setBiayaMasuk && _ctx.setBiayaMasuk(...args))),
                        placeholder: "e.g 20",
                        type: "text",
                        class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3"
                      }, null, 544), [
                        [_vModelText, _ctx.biayaMasuk]
                      ]),
                      _hoisted_29
                    ])
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode("div", _hoisted_33, [
                        _createVNode("img", {
                          onMouseenter: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onOpenPPH(true))),
                          onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onOpenPPH(false))),
                          src: 
                      _ctx.isOpenPPH
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "PPH",
                          message: "Tarif Pajak Penghasilan (PPh) akan dikenakan sebesar 7,5% - 10% untuk barang dengan nilai Deminimus lebih dari 3$.",
                          footer: "",
                          isArrowBottom: false,
                          style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                        }, null, 512), [
                          [_vShow, _ctx.isOpenPPH]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_34, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.PPH = $event)),
                        onInput: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.setPPH && _ctx.setPPH(...args))),
                        placeholder: "e.g 10",
                        type: "text",
                        class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3"
                      }, null, 544), [
                        [_vModelText, _ctx.PPH]
                      ]),
                      _hoisted_35
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode("div", _hoisted_39, [
                        _createVNode("img", {
                          onMouseenter: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onOpenPPN(true))),
                          onMouseleave: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onOpenPPN(false))),
                          src: 
                      _ctx.isOpenPPN
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    ,
                          alt: ""
                        }, null, 40, ["src"]),
                        _withDirectives(_createVNode(_component_Tooltip, {
                          title: "PPN",
                          message: "Besaran Pajak Pertambahan Nilai (PPN) adalah 10%.",
                          footer: "",
                          isArrowBottom: false,
                          style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                        }, null, 512), [
                          [_vShow, _ctx.isOpenPPN]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_40, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.PPN = $event)),
                        onInput: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.setPPN && _ctx.setPPN(...args))),
                        placeholder: "e.g 10",
                        type: "text",
                        class: "py-1.5 xxl:py-3 px-3 rounded-r-none rounded-l-md border border-gray-lp-400 focus:outline-none focus:shadow my-1.5 text-black-lp-300 w-2/3"
                      }, null, 544), [
                        [_vModelText, _ctx.PPN]
                      ]),
                      _hoisted_41
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_42, [
                _hoisted_43,
                _hoisted_44,
                _withDirectives(_createVNode("span", { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }, _toDisplayString(_ctx.errorMessage), 513), [
                  [_vShow, _ctx.isErrorValidation]
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode("div", _hoisted_48, [
                      _createVNode("div", {
                        class: 
                    `relative ${(_ctx.invalidStartDate || _ctx.isExist) && 'date-error'}`
                  
                      }, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.periodeStart,
                          onSelected: _ctx.inputDateStart,
                          minDate: _ctx.tomorrow
                        }, null, 8, ["modelValue", "onSelected", "minDate"]),
                        _withDirectives(_createVNode("div", _hoisted_49, [
                          _hoisted_50
                        ], 512), [
                          [_vShow, _ctx.isExist]
                        ])
                      ], 2)
                    ]),
                    (_ctx.invalidStartDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_51, "Tanggal mulai tidak boleh lebih atau sama dengan tanggal sekarang"))
                      : _createCommentVNode("", true),
                    (_ctx.isErrorValidation)
                      ? (_openBlock(), _createBlock("span", _hoisted_52, [
                          _hoisted_53,
                          _hoisted_54,
                          _hoisted_55,
                          _hoisted_56,
                          _hoisted_57
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("span", _hoisted_58, "Data pajak barang sudah tersedia", 512), [
                      [_vShow, _ctx.isExist]
                    ])
                  ]),
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", {
                        class: 
                    `relative ${(_ctx.invalidEndDate || _ctx.isExist) && 'date-error'}`
                  
                      }, [
                        _createVNode(_component_DatePicker, {
                          modelValue: _ctx.periodeEnd,
                          onSelected: _ctx.inputDateEnd,
                          minDate: _ctx.tomorrow
                        }, null, 8, ["modelValue", "onSelected", "minDate"]),
                        _withDirectives(_createVNode("div", _hoisted_62, [
                          _hoisted_63
                        ], 512), [
                          [_vShow, _ctx.isExist]
                        ])
                      ], 2)
                    ]),
                    (_ctx.invalidEndDate)
                      ? (_openBlock(), _createBlock("span", _hoisted_64, "Tanggal akhir tidak boleh kurang atau sama dengan tanggal sekarang"))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("span", _hoisted_65, [
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _hoisted_70
                    ], 512), [
                      [_vShow, _ctx.isErrorValidation]
                    ]),
                    _withDirectives(_createVNode("span", _hoisted_71, "Data pajak barang sudah tersedia", 512), [
                      [_vShow, _ctx.isExist]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Pembuatan Berhasil !",
      message: `Pajak Barang “${_ctx.commodityName}” berhasil dibuat.`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.disableSubmit ? null : _ctx.onSave,
      isDisabled: _ctx.disableSubmit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Pembuatan",
      message: 
      `Anda yakin ingin menyimpan pembuatan Pajak Barang “${_ctx.commodityName}” ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "isDisabled", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}